import styled from 'styled-components';

export const StyledIndustryContainer = styled.section`
    background: #152637;


    //margin-bottom: -200px;
	.subtitle-ygen{
		@media(max-width: 767px){
			margin-bottom: 30px;
		}
	}

    .fixed-right {
        position: absolute;
        right: 0;
        top: 0;

        svg {
            transform: rotate(360deg);
        }
    }

    &.version_two {
        margin-bottom: 0;

        .col-md-3 {
            padding-bottom: 60px;
            @media (max-width: 767px) {
                padding-bottom: 0;
            }
        }
    }

    &.version_three {
        margin-bottom: 0;
        overflow: hidden;

        .small-text {
            color: #15263780;

            svg {
                path {
                    stroke: #15263780;
                }
            }
        }

        h6 {
            //color: #15263780;
        }

        .col-md-3 {
            padding-bottom: 60px;
            @media (max-width: 767px) {
                padding-bottom: 0;
            }
        }
    }


    @media (max-width: 767px) {
        margin-bottom: 0 !important;
    }

    .create-top-rebon {
        position: relative;
        display: block !important;
		
		&:after{
			background-color: white;
			bottom: 0;
			position: absolute;
			left: 0;
			right: 0;
			width: 100%;
			height: 50%;
			content: '';
			z-index: -1;
            margin-left: ${props => `-${props?.offset+15 + 'px'}` || '0px'};

		}
      
    }

`;
